import React from "react";

import { useTranslation } from "next-i18next";
import Image from "next/image";

import { Blockquote } from "@/components/elements/blockquote/blockquote";
import {
  Box,
  Container,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";

export const AboutContentSection = (): JSX.Element => {
  const { t } = useTranslation("about");
  const theme = useTheme();
  const isGreaterThanTablet = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <>
      <Container disableGutters sx={{ position: "relative" }}>
        <Box sx={{ px: 2, pt: 1 }}>
          <Typography
            variant={"h1"}
            sx={{
              mb: 2,
              textAlign: { xs: "center", md: "start" },
              fontSize: { xs: "24px", md: "48px" },
              fontWeight: 400
            }}
            color={theme.palette.primary.main}>
            {t("title")}
          </Typography>
        </Box>
        <Image
          src={"/images/about/banner-pc.webp"}
          layout={"responsive"}
          width={100}
          height={(9 / 16) * 100}
          objectFit={"cover"}
          style={{ width: "100%", display: "block" }}
          alt={"Bashir"}
          quality={75}
          priority
        />
        <Box sx={{ px: { xs: 2, md: 0 } }}>
          <Typography
            variant={"h2"}
            sx={{ mb: 1, mt: 2.5, fontSize: { xs: "20px", md: "40px" } }}
            color={theme.palette.primary.main}>
            {t("supports")}
          </Typography>
          <Typography
            fontWeight={300}
            sx={{ fontSize: { md: 18 } }}
            color={theme.palette.primary.light}>
            {t("supportsDescription")}
          </Typography>
          <Typography
            variant={"h2"}
            sx={{ mb: 1, mt: 2.5, fontSize: { xs: "20px", md: "40px" } }}
            color={theme.palette.primary.main}>
            {t("mission")}
          </Typography>
          <Typography
            fontWeight={300}
            sx={{ fontSize: { md: 18 } }}
            color={theme.palette.primary.light}>
            {t("missionDescription")}
          </Typography>
          <Typography
            variant={"h2"}
            sx={{ mb: 1, mt: 2.5, fontSize: { xs: "20px", md: "40px" } }}
            color={theme.palette.primary.main}>
            {t("promise")}
          </Typography>
          <Typography
            fontWeight={300}
            color={theme.palette.primary.light}
            sx={{ mb: 2, fontSize: { md: 18 } }}
            whiteSpace={"pre-line"}>
            {t("promiseDescription")}
          </Typography>
        </Box>
      </Container>
      <Blockquote bgcolor={theme.palette.pink.main}>
        <Typography
          sx={{ fontSize: { xs: 16, md: 68 } }}
          whiteSpace={"pre-line"}
          fontWeight={500}>
          <span style={{ color: "white" }}>{t("blockquote1.text1")}</span>
          {t("blockquote1.text2")}
          <span style={{ color: "white" }}>{t("blockquote1.text3")}</span>
        </Typography>
      </Blockquote>
      <Box
        sx={{
          maxHeight: { md: "900px" }
        }}>
        <img
          src={"/images/about/peoples.webp"}
          style={{ width: "100%", display: "block" }}
          alt="people eat"
        />
      </Box>
      <Blockquote bgcolor={theme.palette.green.main}>
        <Typography
          sx={{
            fontSize: { xs: 16, md: 68 },
            "& i": { color: "#FFFFFF", fontStyle: "normal" }
          }}
          whiteSpace={"pre-line"}
          fontWeight={500}>
          {isGreaterThanTablet ? (
            <span dangerouslySetInnerHTML={{ __html: t("blockquote2.full") }}>
              {/*{t("blockquote2.full")}*/}
            </span>
          ) : (
            <>
              {t("blockquote2.text1")}
              <span style={{ color: "white" }}>{t("blockquote2.text2")}</span>
              {t("blockquote2.text3")}
              <span style={{ color: "white" }}>{t("blockquote2.text4")}</span>
              {t("blockquote2.text5")}
            </>
          )}
        </Typography>
      </Blockquote>
      <iframe
        width="100%"
        style={{
          aspectRatio: isGreaterThanTablet ? "1920 / 760" : "375 / 282",
          marginBottom: "50px"
        }}
        src="https://www.youtube.com/embed/-w_ViOy6fds"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen></iframe>
    </>
  );
};
